import { useState, type ComponentProps } from "react";

import { Input } from "@/shared/ui/input";

type ManualPasswordInputProps = Omit<
  ComponentProps<typeof Input>,
  "type" | "autoComplete" | "readOnly"
>;

export function ManualPasswordInput({
  onBlur,
  onCompositionStart,
  onDrop,
  onKeyDown,
  onPaste,
  onPointerUp,
  ...props
}: ManualPasswordInputProps) {
  const [editable, setEditable] = useState(false);

  function allowManualInput(input: HTMLInputElement) {
    input.readOnly = false;
    setEditable(true);
  }

  return (
    <Input
      {...props}
      type="password"
      autoComplete="off"
      readOnly={!editable}
      onPointerUp={(event) => {
        allowManualInput(event.currentTarget);
        onPointerUp?.(event);
      }}
      onKeyDown={(event) => {
        if (event.key !== "Tab") allowManualInput(event.currentTarget);
        onKeyDown?.(event);
      }}
      onPaste={(event) => {
        allowManualInput(event.currentTarget);
        onPaste?.(event);
      }}
      onDrop={(event) => {
        allowManualInput(event.currentTarget);
        onDrop?.(event);
      }}
      onCompositionStart={(event) => {
        allowManualInput(event.currentTarget);
        onCompositionStart?.(event);
      }}
      onBlur={(event) => {
        setEditable(false);
        onBlur?.(event);
      }}
    />
  );
}
